import React from 'react';
import type { CompareBy } from './Activity/QueryBuilder/types';

// --------------------------------------- GENERAL --------------------------------------- //
export const INIT_DEFAULT_RANGE = 7;
export const DOWNLOADS_DIMENSION = 'skadnetwork-valid-messages';
export const REDOWNLOAD_DIMENSION = 'body_redownload';
export const CONVERSION_VALUE_DIMENSION = 'body_conversion_value';
export const MAPPED_CONVERSION_VALUE = 'annotation_conversion_value_mapped_value';
export const MAPPED_ALIAS = 'annotation_customer_event_alias';
export const MAPPED_LOWER_REVENUE = 'annotation_revenue_lower';
export const MAPPED_UPPER_REVENUE = 'annotation_revenue_upper';
export const COARSE_CONVERSION_VALUE = 'body_coarse_conversion_value';
export const SOURCE_IDENTIFIER = 'body_source_identifier';
export const COARSE_CONVERSION_VALUE_DIMENSION = 'body_coarse_conversion_value';
export const AD_NETWORK_NAME_DIMENSION = 'annotation_dollar_3p';
export const SOURCE_APP_ID_DIMENSION = 'body_source_app_id';
export const CAMPAIGN_ID_DIMENSION = 'body_campaign_id';
export const AD_SET_NAME = 'last_attributed_touch_data_tilde_ad_set_name';
export const AD_SET_ID = 'last_attributed_touch_data_tilde_ad_set_id';
export const BODY_LATD_CAMPAIGN_NAME_DIMENSION = 'last_attributed_touch_data_tilde_campaign';
export const BODY_LATD_CAMPAIGN_ID_DIMENSION = 'last_attributed_touch_data_tilde_campaign_id';
export const BODY_TEST = 'body_test';
export const BODY_FIDELITY_TYPE = 'body_fidelity_type';
export const BODY_VERSION = 'body_version';
export const BODY_DID_WIN_DIMENSION = 'body_did_win';
export const ADVERTISER_COPY = 'advertiser_copy';
export const POSTBACK_SEQUENCE_INDEX_DIMENSION = 'body_postback_sequence_index';
export const POSTBACK_SEQUENCE_INDEX_LABEL = 'postback window';
export const INVALID_REASON = 'invalid_reason';
export const TOTAL_COUNT = 'total_count';
export const BODY_LATD_NAME_DIMENSION = 'last_attributed_touch_data_dollar_3p';
export const DATE_RANGE = 'date_range';
export const MULTIPLE_CAMPAIGNS_ASSOCIATIONS = 'multiple_campaigns_associations';
export const DATE = 'date';
export const AD_NETWORK = 'ad network';
export const CAMPAIGN_ID = 'campaign id';
export const PARTNER_CAMPAIGN_ID = 'partner campaign id';
export const INSTALLS = 'installs';
export const REINSTALLS = 'reinstalls';
export const COARSE_VALUE_LOW = 'low';
export const COARSE_VALUE_MEDIUM = 'medium';
export const COARSE_VALUE_HIGH = 'high';
export const CONVERSION_EVENT_INSTALL = 'INSTALL';
export const CONVERSION_VALUE_FOR_INSTALL = '0';
export const INVALID_REASON_LOST_MESSAGE = 'LOST_MESSAGE';
export const INFERRED_CONVERSION_EVENT_LABEL = 'inferred conversion event';
export const EO_DATASOURCES = ['eo_impression', 'eo_click'];
export const INFERRED_COARSE_CONVERSION_LOW = 'conversion_value_low_count';
export const INFERRED_COARSE_CONVERSION_MEDIUM = 'conversion_value_medium_count';
export const INFERRED_COARSE_CONVERSION_HIGH = 'conversion_value_high_count';

export const REDOWNLOAD_VALUES = {
  V1_INSTALL: null,
  INSTALL: 'false',
  REINSTALL: 'true',
};
export const MANDATORY_CONVERSION_VALUE_MAPPING = {
  [CONVERSION_VALUE_FOR_INSTALL]: CONVERSION_EVENT_INSTALL,
};
export const REQUIRED_EO_CAMPAIGN_COMPARE_BY: CompareBy[] = [
  {
    field: {
      displayName: AD_NETWORK,
      dimension: BODY_LATD_NAME_DIMENSION,
    },
  },
  {
    field: {
      displayName: PARTNER_CAMPAIGN_ID,
      dimension: BODY_LATD_CAMPAIGN_ID_DIMENSION,
    },
  },
  {
    field: {
      displayName: DATE,
      dimension: DATE_RANGE,
    },
  },
];
export const MANDATORY_MAPPED_CONVERSION_VALUES_SET: Set<string | null> = new Set(
  Object.keys(MANDATORY_CONVERSION_VALUE_MAPPING)
);
export const ALL_MAPPED_CONVERSION_VALUES: string[] = Array.from(new Array(64), (_, index) => String(index)).filter(
  (conversionValue) => !MANDATORY_MAPPED_CONVERSION_VALUES_SET.has(conversionValue)
);
export const ALL_MAPPED_COARSE_CONVERSION_VALUES: string[] = [COARSE_VALUE_LOW, COARSE_VALUE_MEDIUM, COARSE_VALUE_HIGH];
// ---------------------------------------- REPORT TABS ---------------------------------------- //
export const INIT_REPORT_TYPE = 'ad_networks';
export const REPORT_TAB_CONFIG = [
  {
    key: 'ad_networks',
    title: 'Ad Networks',
    component: <div />,
    hide: false,
    beta: false,
  },
  {
    key: 'campaigns',
    title: 'Campaigns',
    component: <div />,
    hide: false,
    beta: false,
  },
  {
    key: 'source_apps',
    title: 'Source Apps',
    component: <div />,
    hide: false,
    beta: false,
  },
  {
    key: 'conversion_events',
    title: 'Conversion Events',
    component: <div />,
    hide: false,
    beta: false,
  },
  {
    key: 'downloads',
    title: 'Downloads',
    component: <div />,
    hide: false,
    beta: false,
  },
  {
    key: 'custom',
    title: 'Custom Report',
    component: <div />,
    hide: false,
    beta: false,
  },
];
export const REDOWNLOAD_DIMENSION_MAPPING = {
  true: REINSTALLS,
  false: INSTALLS,
  null: INSTALLS,
};
